import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import MDButton from "../../components/MDButton";
import {addSquarePayment} from "./api/WebApi";
import MDTypography from "../../components/MDTypography";
import Grid from "@mui/material/Grid";
import SquareCheckoutPage from "../SquareCheckoutPage";

export default function SquareAddPayment({show, client, handleClose}) {

  const [context, setContext] = useContext(AppContext);
  const [actionPending, setActionPending] = useState(false);

  const initTerminal = () => {
    addSquarePayment(client?.guid).then((resp) => {
      setActionPending(true);
    });
  }

  const [manualAddPayment, setManualAddPayment] = useState(false);

  const initKeypress = () => {
    addSquarePayment(client?.guid).then((resp) => {
      console.dir(resp);
      setActionPending(true);
    });
  }

  const [cart, setCart] = useState({
    storeCardOnly: true
  });

  return (
    <Modal onHide={handleClose} size={'md'} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Add Payment Method</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className={'col col-main'} xs={12}>
            <Container>
              <Row>
                <Col className={'col'} xs={12}>
                  <center>
                    <MDTypography
                      fontWeight={'light'}
                      variant={"h5"}>Save card on file for {client.firstName} {client.lastName}</MDTypography>
                    {!manualAddPayment && <Grid container>
                      <Grid item sm={6}>
                        <MDButton color="primary"
                                  style={{
                                    marginTop: '12px'
                                  }}
                                  disabled={actionPending}
                                  onClick={() => {
                                    setManualAddPayment(true);
                                  }}><span className={'fa fa-credit-card'}></span>&nbsp;Enter Manually
                        </MDButton>
                      </Grid>
                      <Grid item sm={6}>
                        <MDButton color="primary"
                                  style={{
                                    marginTop: '12px'
                                  }}
                                  disabled={actionPending}
                                  onClick={() => {
                                    initTerminal()
                                  }}><span className={'fa fa-credit-card'}></span>&nbsp;Continue on terminal
                        </MDButton>
                      </Grid>
                    </Grid> }

                  </center>
                </Col>
              </Row>
              {manualAddPayment && <Row>
                <Col sm={12}>
                  <SquareCheckoutPage
                    handleSuccess={(e) => {
                      console.dir(e)
                      handleClose()
                    }}
                    handleError={(e) => {
                      let _cart = {...cart};
                      _cart.checkoutDisposition = 'CART_API_ERROR';
                      _cart.error = e.message;
                      setCart(_cart);
                    }}
                    storeCard={true}
                    client={client}
                    cart={cart}/>
                </Col>
              </Row>}

            </Container>
          </Col>
        </Row>

      </Modal.Body>

      <Modal.Footer>
        <MDButton
          style={{marginLeft: '10px'}}
          type="submit"
          disabled={!actionPending}
          onClick={() => {
            handleClose();
          }}
          color="info">
          Done
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}